import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'

export function useGetProfileErrorTranslation(): (error: unknown) => string {
  const { i18n, t } = useTranslation()

  return useCallback(
    (error: unknown) => {
      let errorKey = 'common.pleaseTryAgainErrorMessage'

      if (error instanceof AxiosError && !!error.response?.data?.key) {
        const key = `portal.profile.profileServiceErrors.${error.response?.data?.key}`

        if (i18n.exists(key)) {
          errorKey = key
        }
      }

      // dynamic keys that may not be known at compile time. We ensure the key exists at runtime with i18n.exists()
      // before calling t(), so this is safe.
      // @ts-ignore
      return t(errorKey)
    },
    [i18n, t]
  )
}
